import React from 'react';
import PropTypes from 'prop-types';
// Material UI
import { withTheme } from '@material-ui/core/styles';
// Custom
import { getHocDisplayName } from 'utils/Tools';

const withThemeColors = (WrappedComponent) => {
  const WithThemeColors = ({ theme, ...otherProps }) => {
    const {
      palette: {
        primary,
        secondary,
        error,
        warning,
        info,
        success,
      },
    } = theme;

    return (
      <WrappedComponent
        themeColors={{
          primary: primary.main,
          secondary: secondary.main,
          error: error.main,
          warning: warning.main,
          info: info.main,
          success: success.main,
        }}
        {...otherProps}
      />
    );
  };

  WithThemeColors.displayName = getHocDisplayName('WithThemeColors', WrappedComponent);

  WithThemeColors.propTypes = {
    theme: PropTypes.shape({
      palette: PropTypes.shape({
        primary: PropTypes.object.isRequired,
        secondary: PropTypes.object.isRequired,
        error: PropTypes.object.isRequired,
        warning: PropTypes.object.isRequired,
        info: PropTypes.object.isRequired,
        success: PropTypes.object.isRequired,
      }).isRequired,
    }).isRequired,
  };

  return withTheme(WithThemeColors);
};

export default withThemeColors;



// WEBPACK FOOTER //
// ./components/core/hocs/WithThemeColors.js